import { string, object } from 'yup';

const schema = object().shape({
  email: string().required('requiredField').email('invalidEmailAddress'),
  password: string().required('requiredField').min(6, 'minSixCharacters')
});

export default schema;